import { render, staticRenderFns } from "./ProductsSwiper.vue?vue&type=template&id=5eafe655&scoped=true"
import script from "./ProductsSwiper.vue?vue&type=script&lang=ts"
export * from "./ProductsSwiper.vue?vue&type=script&lang=ts"
import style0 from "./ProductsSwiper.vue?vue&type=style&index=0&id=5eafe655&prod&lang=scss"
import style1 from "./ProductsSwiper.vue?vue&type=style&index=1&id=5eafe655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eafe655",
  null
  
)

export default component.exports